import React from 'react';
import PropTypes from 'prop-types';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';

const GenericFailureMessage = ({ text, onDismiss }) => (
  <Message
    type="error"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        {text}
      </MessageContent>
    )}
  />
);

GenericFailureMessage.displayName = 'GenericFailureMessage';

GenericFailureMessage.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
  text: PropTypes.string,
};

GenericFailureMessage.defaultProps = {
  text: 'Oops, something went wrong.',
};

export default GenericFailureMessage;
